import { useQuery } from '@tanstack/react-query';
import { fetchFolderTypes } from '../../../../api/administration/edmsSettings/folderTypes';

/** Normalize list from common API response shapes. */
function getFolderTypesList(response) {
  if (!response) return [];
  const inner = response.data;
  if (Array.isArray(inner?.folderTypes)) return inner.folderTypes;
  if (Array.isArray(inner?.data)) return inner.data;
  if (Array.isArray(inner?.results)) return inner.results;
  if (Array.isArray(inner?.items)) return inner.items;
  if (Array.isArray(response.folderTypes)) return response.folderTypes;
  if (Array.isArray(inner)) return inner;
  if (Array.isArray(response.data)) return response.data;
  return [];
}

/** Normalize pagination from common API response shapes. */
function getPagination(response, fallbackPageSize) {
  const inner = response?.data;
  const pagination = inner?.pagination ?? inner?.meta ?? response?.pagination ?? response?.meta;
  if (pagination && typeof pagination === 'object') {
    return {
      currentPage: pagination.currentPage ?? pagination.page ?? pagination.current_page ?? 1,
      pageSize: pagination.pageSize ?? pagination.limit ?? pagination.per_page ?? fallbackPageSize,
      totalItems: pagination.totalItems ?? pagination.total ?? pagination.total_items ?? 0,
      totalPages: pagination.totalPages ?? pagination.total_pages ?? 0,
      hasNextPage: pagination.hasNextPage ?? pagination.has_next_page ?? false,
      hasPrevPage: pagination.hasPrevPage ?? pagination.has_prev_page ?? false,
    };
  }
  return {
    currentPage: 1,
    pageSize: fallbackPageSize ?? 10,
    totalItems: 0,
    totalPages: 0,
    hasNextPage: false,
    hasPrevPage: false,
  };
}

export const useFolderTypes = (filters, options = {}) => {
  const query = useQuery({
    queryKey: ['folderTypes', filters],
    queryFn: () => fetchFolderTypes(filters),
    keepPreviousData: true,
    enabled: options.enabled,
  });

  const pageSize = filters?.pageSize ?? 10;

  return {
    ...query,
    data: getFolderTypesList(query.data),
    pagination: getPagination(query.data, pageSize),
  };
};

export default useFolderTypes;
